export const stripHTML = (HTMLInput: string): string => {
  if (!HTMLInput) return ''
  const temporaryElement = document.createElement('div')
  temporaryElement.innerHTML = HTMLInput
  return temporaryElement.textContent || temporaryElement.innerText || ''
}

export const limitChars = (
  input: string,
  limit: number,
  ellipsis?: Boolean,
): string => {
  if (input.length > limit) {
    return `${input.substring(0, limit)}${ellipsis ? '...' : ''}`
  }
  return input
}

export const concatObjectValues = (
  object: Object,
  separator: string,
): string => {
  const values = Object.values(object)
  return values.reduce((a, b) => a + separator + b)
}

export const createQueryString = (object: object): string => {
  const stripEmpty = Object.fromEntries(
    Object.entries(object).filter(([, value]) => value !== ''),
  )
  const searchParams = new URLSearchParams(stripEmpty)
  return searchParams.toString()
}

export const toSentenceCase = (string: string): string => string.charAt(0).toUpperCase()
  + string
    .slice(1)
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()

export const stripEmptyFromObject = (object: object): Object => {
  // eslint-disable-next-line no-control-regex
  const controlCharRegex = /[\x00-\x1F\x7F]/g
  return Object.fromEntries(
    Object.entries(object)
      .filter(([, value]) => value !== '' && value !== undefined && value !== null && value !== ' ')
      .map(([key, value]) => [
        key,
        typeof value === 'string'
          ? value.replace(controlCharRegex, '').trim()
          : value,
      ]),
  )
}

export function stripEmptyFromArray<T>(array: (T | null | undefined)[]): T[] {
  return array.filter(
    (value): value is T => value !== '' && value !== undefined && value !== null && value !== ' ',
  )
}

export function stripFalseFromObject<T extends Record<PropertyKey, unknown>>(
  object: T,
): Partial<T> {
  return Object.keys(object).reduce((acc, key) => {
    const value = object[key]
    if (value !== false) return { ...acc, [key]: value }
    return acc
  }, {})
}

export const onlyString = (input: string): string => input.replace(/[^a-zA-Z0-9]/g, '')

export const truncate = (input: string, limit: number): string => {
  if (input.length > limit) {
    return input.slice(0, limit).concat('...')
  }
  return input
}

// to ensure HTML codes like `&#163;` aren't escaped
export const parseString = (input: string | undefined): string => new DOMParser().parseFromString(`<!doctype html><body>${input}`, 'text/html')
    .body.textContent || ''

export const capitalize = (string: string | undefined): string => (string ? string[0].toUpperCase() + string.substring(1) : '')

export const sortAlphabeticallyByKey = <T>(
  a: T,
  b: T,
  key: keyof T,
): number => {
  if (a[key] < b[key]) return -1
  if (a[key] > b[key]) return 1
  return 0
}

export const toSentence = (...strings: (string | undefined)[]): string => stripEmptyFromArray(strings).join(' ')
